import React from 'react';
import styles from './SkinTypeSelector.module.scss';
import { BiChevronDown } from 'react-icons/bi';
import { $t } from '../../../helpers/translator';


class SkinTypeSelector extends React.Component {
    constructor(props) {
        super(props);

        // console.log('skintttype', props);

        this.state = {
            types: [
                {
                    name: $t('global.general.type') + ' 1',
                    color: '#f4d0b1',
                    value: 1
                },
                {
                    name: $t('global.general.type') + ' 2',
                    color: '#e7b48f',
                    value: 2
                },
                {
                    name: $t('global.general.type') + ' 3',
                    color: '#d29e7c',
                    value: 3
                },
                {
                    name: $t('global.general.type') + ' 4',
                    color: '#ba7750',
                    value: 4
                },
                {
                    name: $t('global.general.type') + ' 5',
                    color: '#a55d2b',
                    value: 5
                },
                {
                    name: $t('global.general.type') + ' 6',
                    color: '#3c201d',
                    value: 6
                },
            ],
            selected: this.props.skinType ? Number(this.props.skinType) : null
        };

    }
    componentDidMount() {
        if (this.props.skinType) {
            let skinType = this.props.skinType;
            if (typeof(skinType) === 'string' && Number.isInteger(parseInt(skinType))) {
                skinType = parseInt(skinType);
            }

            this.selectSkinType(skinType);
        }

        // console.log('skintype props', this.props)
        // console.log('skintype state', this.state)
    }

    selectSkinType(value) {

        if (this.props.disabled) {
            return;
        }

        this.setState({ selected: value }, () => {
            // console.log(value)
            this.props.onValueChange({
                value: value
            })
        });
    }

    render() {
        const { selected } = this.state;
        const disabled = !!this.props.disabled;

        return (
            <div className={`${styles['container']}` }>
                {
                    this.state.types.map((option, k) => (
                        <div className={`${styles['option-container']} ${(option.value === selected ? styles['option-container-selected'] : '')}` } key={k}>
                            <div onClick={() => this.selectSkinType(option.value)}
                                 className={`${styles['option-color']} ${styles[(option.value === 1 || option.value === 6 ? 'oc-' + option.value : '')]} ${(option.value === selected ? styles['oc-selected'] : '')} ${styles[(disabled ? ' cursor-regular' : '')]}` }
                                 style={{ backgroundColor: option.color }}>
                                {
                                    <div className={`${styles.selectedTextContainer}`}>{(option.value === selected ? option.name : '')}</div>
                                }

                            </div>

                            {/*<div className={`${styles[(option.value !== selected ? 'hidden' : '')]} ${styles.selectedContainer}` }>*/}
                            {/*    <div className={`${styles['option-arrow']} ${styles['flex-center']}` }>*/}
                            {/*        <BiChevronDown/>*/}
                            {/*    </div>*/}
                            {/*    <div className={`${styles['option-name']} ${styles['flex-center']}` }>*/}
                            {/*        {option.name}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>


                    ))
                }
            </div>
        );
    }
}

export default SkinTypeSelector;
